const TRUST_SIGNALS = [
  'Free for core features',
  'Private by design',
  'Works offline',
  '24 fellowships supported',
  'No credit card required',
];

export function TrustBar() {
  return (
    <div className="bg-navy-800 border-y border-white/5 py-3 px-4">
      <ul role="list" className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1">
        {TRUST_SIGNALS.map((signal, index) => (
          <li key={signal} className="flex items-center gap-3">
            <span className="text-sm text-slate-400 whitespace-nowrap">{signal}</span>
            {index < TRUST_SIGNALS.length - 1 && (
              <span className="text-white/15 select-none hidden sm:inline" aria-hidden="true">
                ·
              </span>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
